import { env } from '../../../../lib/env'
import { WEB_REGISTER } from '../web-register.constant'

/**
 * Helper to get the core config properties to identify Web Register with the tracking service.
 */
export function getCoreTrackingConfig() {
  return {
    defaultModuleName: WEB_REGISTER.DISPLAY_NAME,
    environment: env.get(),
    systemName: WEB_REGISTER.APPLICATION_NAME,
    systemVersion: WEB_REGISTER.CLIENT_VERSION,
  }
}
